import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'

export default class TabIndicator extends Component {
  static propTypes = {
    children: PropTypes.array.isRequired,
    style: PropTypes.object,
    defaultSelectedTab: PropTypes.number,
    onChangeTab: PropTypes.func
  }

  static defaultProps = {
    defaultSelectedTab: 1,
    children: []
  }

  constructor (...args) {
    super(...args)

    const { defaultSelectedTab } = this.props

    this.state = {
      selectedTab: defaultSelectedTab
    }

    this._handleClick = this._handleClick.bind(this)
  }

  _renderChildren () {
    const { children } = this.props
    return children && Array.isArray(children) && children.map((child, index) => {
      const handleClick = () => this._handleClick(index + 1)
      const newChild = React.cloneElement(child, { onClick: handleClick })
      return (
        <Fragment
          key={index}
        >
          {newChild}
        </Fragment>
      )
    })
  }

  _handleClick (selectedTab) {
    const { onChangeTab } = this.props
    const index = selectedTab || 1
    this.setState({ selectedTab: index }, () => onChangeTab && onChangeTab(index))
  }

  render () {
    return (
      <Fragment>
        {this._renderChildren()}
      </Fragment>
    )
  }

  // UNSAFE_componentWillReceiveProps(nextProps) {
  //   if (Object.keys(nextProps).includes('selectedTab') && nextProps.selectedTab !== this.state.selectedTab) {
  //     this._handleClick(nextProps.selectedTab)
  //   }
  // }
  //
  // componentDidMount() {
  //   this._handleClick(this.state.selectedTab)
  // }
}
